import * as ScrollArea from "@radix-ui/react-scroll-area";
import { ReactNode } from "react";
import * as SC from "./options-wrapper.styles";

export const OptionsWrapper = ({ children }: { children: ReactNode }) => {
  return (
    <SC.ScrollAreaWrapper>
      <ScrollArea.Viewport asChild>
        <SC.OptionsWrapper>{children}</SC.OptionsWrapper>
      </ScrollArea.Viewport>
      <ScrollArea.Scrollbar orientation="vertical">
        <ScrollArea.Thumb />
      </ScrollArea.Scrollbar>
    </SC.ScrollAreaWrapper>
  );
};
